export const leadsCardHeaders = [
  {
    text: "Actions",
    value: "actions",
    sortable: false,
    width: "80px"
  },
  {
    text: "Name",
    value: "customer_first_name",
    width: "100px"
  },
  {
    text: "Phone",
    value: "phone",
    width: "100px"
  },
  {
    text: "Facility",
    value: "facility.location_code",
    width: "90px"
  },
  {
    text: "Move-In",
    value: "move_in_date",
    width: "100px"
  }

];
